export abstract class TemplateEngine implements ITemplateEngine {
  build(): string {
    return "";
  }
}
